module.exports = __webpack_public_path__ + "img/malldelt.96cb412b.png";